// eslint-disable-next-line no-restricted-imports
import { useSelector } from "react-redux";

import { type DeprecatedReduxState } from "./types";

export function useWorkplaceType() {
  const session = useSelector((state: DeprecatedReduxState) => state.session);

  return session.profile?.type;
}
